import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-play_btn",
  "use": "spr-play_btn-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"spr-play_btn\">\n\n<g>\n\t<path d=\"M256,25.6C383,25.6,486.4,129,486.4,256S383,486.4,256,486.4S25.6,383,25.6,256S129,25.6,256,25.6 M256,0\n\t\tC114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0L256,0z\" />\n\t<path d=\"M358.3,228.2L222,138.5c-23.5-15.5-42.8-5.1-42.8,23.1v188.8c0,28.2,19.3,38.6,42.8,23.2l136.2-89.1\n\t\tC381.8,269,381.8,243.7,358.3,228.2z M340.1,265.6l-121,79.2c-7.9,5.1-14.3,1.7-14.3-7.7V174.9c0-9.4,6.4-12.8,14.3-7.7l121.1,79.7\n\t\tC348,252,348,260.4,340.1,265.6z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/play_btn.svg
// module id = 341
// module chunks = 0